// client/src/pages/AccessDenied.tsx
// Standalone forbidden page — no shell, no API calls, no sensitive context.
// Reached via window.location.replace('/access-denied') in AuthContext
// so the browser history entry is replaced (no back-button bypass).

import React from 'react';

export default function AccessDenied() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0d0f17',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      padding: 24,
    }}>
      <div style={{
        width: '100%',
        maxWidth: 480,
        background: '#13151f',
        border: '1px solid rgba(255,107,107,.25)',
        borderRadius: 14,
        padding: '40px 36px',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(0,0,0,.5)',
      }}>
        <div style={{
          width: 56, height: 56,
          borderRadius: '50%',
          background: 'rgba(255,107,107,.12)',
          border: '1px solid rgba(255,107,107,.3)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: 24,
        }}>
          🔒
        </div>

        <div style={{ fontSize: 22, fontWeight: 700, color: '#e0e4f0', marginBottom: 10 }}>
          Access Denied
        </div>

        <div style={{ fontSize: 14, color: '#8b95b0', lineHeight: 1.6, marginBottom: 28 }}>
          This application is restricted to <strong style={{ color: '#c0c8e0' }}>BMSS employees</strong> only.
          Your account does not have permission to access Admin HQ.
        </div>

        <div style={{
          background: 'rgba(255,107,107,.07)',
          border: '1px solid rgba(255,107,107,.15)',
          borderRadius: 8,
          padding: '12px 16px',
          fontSize: 13,
          color: '#8b95b0',
          marginBottom: 28,
        }}>
          If you believe this is an error, contact{' '}
          <a href="mailto:DataAnalyticsTeam@bmss.com" style={{ color: '#7aa2ff', textDecoration: 'none' }}>
            the Data Analytics Team
          </a>.
        </div>

        <a
          href="/.auth/logout"
          style={{
            display: 'inline-block',
            padding: '10px 24px',
            borderRadius: 8,
            background: 'rgba(255,255,255,.06)',
            border: '1px solid rgba(255,255,255,.12)',
            color: '#8b95b0',
            fontSize: 14,
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          Sign out
        </a>
      </div>
    </div>
  );
}
